import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-field",
  templateUrl: "./field.component.html",
  styleUrls: ["./field.component.scss"],
})
export class FieldComponent implements OnInit {
  @Input() data: any;
  @Input() inputData: any;
  inputField: any;
  droppedFields: any[] = [];
  fields: any[] = [];

  constructor() {}

  ngOnInit() {
    console.log("inputField", this.inputField);

    if (this.inputData) {
      console.log("inputdata", this.inputData);
    }
    this.droppedFields = this.inputData.map((field) => ({
      ...field,
      dropped: false,
    }));
  }

  addItem() {
    this.fields.push({});
  }

  removeItem() {
    this.fields.pop();
  }

  onDragStart(event: DragEvent, field: any) {
    // console.log(' field data:', this.inputdata);
    console.log(" field data:", field);

    if (field.dropped) {
      event.preventDefault();
      return;
    } 

    // event.dataTransfer.setData('application/json', this.data  );
    event.dataTransfer.setData("application/json", JSON.stringify(field));
  }
}

export interface iField {
  labelname: string;
}
